export const stringValidatorRegex = /^[a-zA-Z-' ]+$/
export const emailValidatorRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const addressValidatorRegex = /^[a-zA-Z0-9-' ]+$/
export const postCodeValidatorRegex = /^\d{4}$/
export const contactNumberValidateRegex = /^\d{10}$/
export const passwordValidatorRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]).{8,}$/
export const tfnValidatorRegex = /^\d{9}$/;
export const abnValidatorRegex = /^\d{11}$/;

